module.exports = __webpack_public_path__ + "static/media/msg-building.c6de755d.svg";